<template>
    <div id="app">
        <div class="contain"></div>

        <sidebar/>
        <sidebar-toggle/>
    </div>
</template>

<script>
    import Sidebar from '../utility/MenuSideBar/Sidebar.vue'
    import SidebarToggle from '../utility/MenuSideBar/SidebarToggle.vue'

    export default {
        name: "WorkSpace",
        components: {
            Sidebar, SidebarToggle
        }
    }
</script>

<style scoped>
    .contain{
        position: fixed;
        left: 0;
        top: 0;
        height: 100vh;
        width: 100vw;
        background-color: #820263;
    }
</style>